import React from 'react';
import { ChevronDown } from 'styled-icons/boxicons-regular/ChevronDown';
import { TriangleDown } from 'styled-icons/entypo/TriangleDown';

function ArrowIconOutline(props) {
  const { className } = props;
  const styles = [className, 'icon'];
  return (
    <ChevronDown {...props} className={styles} />
  );
}

function ArrowIcon(props) {
  const { className } = props;
  const styles = [className, 'icon'];
  return (
    <TriangleDown {...props} className={styles} />
  );
}

export { ArrowIcon, ArrowIconOutline };
